module.exports = __webpack_public_path__ + "img/vito_grazio.746d0352.jpg";